module.exports = __webpack_public_path__ + "static/buscamos_soluciones-4456804f3061b3c389bd07945b63f986.png";